import { SponsorLevel } from 'src/interfaces/profile';

export const BRONZE: SponsorLevel = 'bronze';
export const SILVER: SponsorLevel = 'silver';
